import { client, useApiGet } from "./_base";

export interface ProductCharacteristics {
  id?: number;
  characteristic_code: string;
  characteristic_description: string;
  labelinggroup_id: number;
  paltrack_label_processed: number;
  created_at: Date;
  updated_at: Date;
}

interface ProductCharacteristicsFull extends ProductCharacteristics {
  group_code: string;
  group_description: string;
}

const endpoint = "productcharacteristics";

export const productcharacteristics = client<ProductCharacteristics>(endpoint, (item) => ({
  ...item,
}));

export const getProductCharacteristicsFull = async (): Promise<ProductCharacteristicsFull[]> => useApiGet(`${endpoint}/ext/all`);
